// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.encounter.plan.EncounterAddCarePlanItemsToPersonDiagnosisRequest */
/* istanbul ignore next */
@GandalfModel
export class EncounterAddCarePlanItemsToPersonDiagnosisRequest extends GandalfModelBase {

	@GandalfValidator({ notNull: { message: 'Care Plan Items are required' } })
	@GandalfArray(Number)
	carePlanItemIds!: number[];

	@GandalfValidator({ notNull: { message: 'Diagnosis is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	personDiagnosisId!: number;

}
